import { AxiosError } from "axios";
import { ProblemDetails } from "../Types/Errors/ProblemDetails";
import { BadRequestObjectResult } from "../Types/Errors/BadRequestObjectResult";
import { ODataError } from "../Types/Errors/ODataError";
import { JsonResult } from "../Types/Errors/JsonResult";
import { BadRequestValidationErrors, ValidationResult } from "../Types/Errors/BadRequestValidationErrors";
import { AxiosErrorTypes } from "../Types/Errors/AxiosErrorTypes";

export const setResponseMessage = (operationType?: string): string => {
  let response = ""
  switch (operationType) {
    case "DeleteDuType":
      response = "Container Type deleted successfully."
      break;

    case "EditDuType":
      response = "Container Type updated successfully."
      break;

    case "CreateDuType":
      response = "Container Type created successfully."
      break;
    case "DeleteFamilyGroup":
      response = "Family Group deleted successfully."
      break;

    case "EditFamilyGroup":
      response = "Family Group updated sucessfully, Updates will reflect after 5 minutes."
      break;

    case "CreateFamilyGroup":
      response = "Family Group created successfully."
      break;

    default:
      response = "Unable to perform operation."
      break;
  }
  return response
}

function determineAxiosErrorType(error: AxiosError): AxiosErrorTypes {
  const problemDetailsProps: Array<keyof ProblemDetails> = ["title", "detail", "status"];
  const badRequestProps: Array<keyof BadRequestObjectResult> = ["ContentType", "StatusCode", "Value"];
  const badRequestValidationErrorsProps: Array<keyof BadRequestValidationErrors> = ["IsValid", "StatusCode", "ValidationErrors"];
  const oDataErrorProps: Array<keyof ODataError> = ["error"];

  const errorResponseData = error?.response?.data;

  if (errorResponseData && typeof errorResponseData === "object") {

    if (problemDetailsProps.some(prop => prop in errorResponseData)) {
      return "ProblemDetails";
    }

    if (badRequestProps.some(prop => prop in errorResponseData)) {
      return "BadRequestObjectResult";
    }

    if (badRequestValidationErrorsProps.some(prop => prop in errorResponseData)) {
      return "BadRequestValidationErrors";
    }

    if (oDataErrorProps.some(prop => prop in errorResponseData)) {
      return "ODataError";
    }

  }

  if (errorResponseData && Array.isArray(errorResponseData) && errorResponseData.length > 0) {
    return "ErrorArray";
  }

  return "UnknownError";
}

function extractBadRequestError(errorResponseData: any): string | string[] | null {
  const jsonResultProps: Array<keyof JsonResult> = ["statusCode", "errorMsg"];
  const badRequestResult: BadRequestObjectResult = errorResponseData as BadRequestObjectResult;

  const badRequestvalue: object | null = badRequestResult?.Value;
  if (badRequestvalue && jsonResultProps.some(prop => prop in badRequestvalue)) {
    const jsonResult: JsonResult = badRequestvalue as JsonResult;
    if (jsonResult?.errorMsg) {
      return jsonResult.errorMsg;
    }
  }

  const validation: BadRequestValidationErrors = errorResponseData as BadRequestValidationErrors;
  if (validation?.ValidationErrors?.length > 0) {
    return validation.ValidationErrors.map(validation => validation?.ErrorMessage);
  }

  return null;
}

export function extractErrorMessage(error: AxiosError): string | string[] {

  const errorType: AxiosErrorTypes = determineAxiosErrorType(error);
  const errorResponseData = error?.response?.data;

  switch (errorType) {
    case "ProblemDetails": {
      const problemDetails: ProblemDetails = errorResponseData as ProblemDetails;

      if (problemDetails?.detail) {
        return problemDetails.detail;
      }

      if (problemDetails?.title) {
        return problemDetails.title;
      };

      break;
    }

    case "BadRequestObjectResult":
    case "BadRequestValidationErrors": {
      const errorMessage = extractBadRequestError(errorResponseData);
      if (errorMessage) {
        return errorMessage;
      }

      break;
    }

    case "ODataError": {
      const oDataError: ODataError = errorResponseData as ODataError;

      if (oDataError?.error?.message) {
        return oDataError.error.message;
      }

      break;
    }

    case "ErrorArray": {
      const validationResultProps: Array<keyof ValidationResult> = ["ErrorMessage", "MemberNames"];

      const errorArray = errorResponseData as Array<any>;
      if (validationResultProps.some(prop => prop in errorArray[0])) {
        const validationErrors = errorResponseData as Array<ValidationResult>;

        return validationErrors.map(validation => validation?.ErrorMessage);
      }

      break;
    }
  }

  return error?.message || `An error occurred with status code: ${error.status}`;
}